type GoogleResponse = {
    aantalRijen: number
    aantalKolommen: number
    data: string[][]
}

/**
 * Deze functie benadert de Google Visualization API, en voert de gegeven zoekterm uit op het gegeven spreadsheet.
 * 
 * Normaal zou dit via een functie van Google zelf gaan, maar daar lijkt geen library voor te zijn.
 * Deze functie doet die functionaliteit daarom na.
 * 
 * @returns Deze functie geeft een GoogleResponse terug, waar de data in staat als een lijst van rijen. Waarbij elke 
 * rij een lijst aan waardes is. Alleen als een cel data bevat wordt hij in de rij gezet.
 */
const zoekInSheet = (spreasheetId: string, zoekterm: string): Promise<GoogleResponse> => {
        return fetch(`https://docs.google.com/spreadsheets/d/${spreasheetId}/gviz/tq?tq=${encodeURIComponent(zoekterm)}`)
            .then(res => res.text())
            .then(body => {
                const response = body.match(/google\.visualization\.Query\.setResponse\((.*)\);/)
                if (response && response.length >= 1) {
                    const data = JSON.parse(response[1]);

                    if (data.status === "error") {
                        console.error(data.errors)
                        return Promise.reject("Fout(en) bij het ophalen van de data");
                    } else {
                        return {
                            aantalKolommen: data.table.cols.length,
                            aantalRijen: data.table.rows.length,
                            data: data.table.rows.map((row: any) => row.c.filter((c: any) => !!c).map((c: any) => c.v))
                        }
                    }

                } else {
                    return Promise.reject("De foto's konden niet worden gevonden");
                }
            })
}

export const googleBesturing = {
    zoekInSheet
}